var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { cloneDeep } from "lodash";
import Card from "@irati/ui/src/Layout/Card";
import TransferFromTenantToRewardMutation from "@irati/wallet/apollo/mutation/TransferFromTenantToReward";
import TenantWalletBalanceQuery from "@irati/wallet/apollo/query/TenantWallet";
import TransferType from "@irati/wallet/enums/TransferType";
import { subtractCostFromBalance } from "@irati/payments/utils";
import History from "@irati/utils/history";
import tracking from "@irati-tracking/wallet/tenantWallet";
import TenantWalletTransferType from "@irati/wallet/enums/TenantWalletTransferType";
import { FormattedMessage } from "@irati/utils/lang";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import { Strong } from "@irati/ui/src/Labels";
import authentication from "@irati/auth";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import { returnUserTextWithAndOrComma } from "@irati/wallet/helpers";
import ConfirmationPopup from "@irati-web/reward/src/components/ConfirmationPopup";
import Amount from "../Amount";
import Button from "./Button";
import Recipients from "./Recipients";
import Totals from "./Totals";
import { CreditTransferConfirmationPopup } from "../WalletPopups";
var DEFAULT_AMOUNT = "10.00";
var TenantWalletTransfer = /** @class */ (function (_super) {
    __extends(TenantWalletTransfer, _super);
    function TenantWalletTransfer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            amount: DEFAULT_AMOUNT,
            recipients: [],
            showConfirmation: false,
            showPreConfirmationPopup: false
        };
        _this.onCompleted = function () {
            tracking.completeTenantWalletTransferCredit();
            _this.setState({ showConfirmation: true });
        };
        _this.addRecipient = function (user) {
            tracking.selectManager();
            var recipients = cloneDeep(_this.state.recipients);
            recipients.push(user);
            _this.setState({ recipients: recipients });
        };
        _this.removeRecipient = function (user) {
            var recipients = cloneDeep(_this.state.recipients).filter(function (u) { return u.uuid !== user.uuid; });
            _this.setState({ recipients: recipients });
        };
        _this.updateAmount = function (amount) {
            tracking.updateTransferValue();
            _this.setState({ amount: amount });
        };
        _this.handleClose = function () {
            History.push({
                pathname: "/wallet/tenant"
            });
        };
        _this.handleRepeatAgain = function () {
            _this.setState({ showConfirmation: false, recipients: [], amount: DEFAULT_AMOUNT });
        };
        _this.handleClick = function (mutate) {
            tracking.clickTransferCreditCTA();
            mutate();
        };
        _this.handleHide = function () {
            _this.setState({ showPreConfirmationPopup: false });
        };
        _this.handleContinue = function () {
            _this.setState({ showPreConfirmationPopup: true });
        };
        _this.buildUsers = function () {
            var recipients = _this.state.recipients;
            return recipients.map(_this.userToNameAndEmail);
        };
        _this.userToNameAndEmail = function (user, index) {
            var recipients = _this.state.recipients;
            var text = returnUserTextWithAndOrComma(recipients.length, index, "wallet.tenant.transfer.confirmationPopup.text1.user", "wallet.tenant.transfer.confirmationPopup.text1.userWithComma", "wallet.tenant.transfer.confirmationPopup.text1.userWithAnd");
            return (React.createElement("div", { className: "text-center" },
                React.createElement(FormattedMessage, { id: text, values: {
                        name: firstnameLastname(user),
                        email: user.email
                    } })));
        };
        return _this;
    }
    TenantWalletTransfer.prototype.render = function () {
        var _this = this;
        var _a = this.state, amount = _a.amount, recipients = _a.recipients, showConfirmation = _a.showConfirmation, showPreConfirmationPopup = _a.showPreConfirmationPopup;
        var id = this.props.id;
        var totalAmount = Number(amount) * recipients.length;
        return (React.createElement(Card, null,
            React.createElement(TenantWalletBalanceQuery, null, function (_a) {
                var data = _a.data;
                var _b = data.tenantWallet, availableBalance = _b.availableBalance, currency = _b.currency;
                var variables = {
                    amount: amount,
                    currency: currency,
                    recipientIds: recipients.map(function (r) { return r.uuid; }),
                    tenantId: authentication.userTenant().uuid,
                    walletType: TransferType.REWARDS
                };
                var remainderBalance = subtractCostFromBalance({
                    amount: availableBalance,
                    currency: currency
                }, {
                    amount: Number(amount) * recipients.length,
                    currency: currency
                });
                var insufficientFunds = remainderBalance.amount < 0;
                return (React.createElement(React.Fragment, null,
                    React.createElement(TransferFromTenantToRewardMutation, { onCompleted: _this.onCompleted, variables: variables }, function (mutate, apolloState) {
                        return (React.createElement(React.Fragment, null,
                            React.createElement(Amount, { amount: amount, id: id, name: "TenantWalletTransferAmount", label: "wallet.tenant.transfer.amount.label", updateAmount: _this.updateAmount }),
                            React.createElement(Recipients, { addRecipient: _this.addRecipient, recipients: recipients, removeRecipient: _this.removeRecipient }),
                            React.createElement(Totals, { amount: totalAmount, currency: currency, recipients: recipients, updatedBalance: remainderBalance, wallet: data.tenantWallet }),
                            React.createElement(Button, { apolloState: apolloState, disabled: recipients.length === 0 || apolloState.loading || insufficientFunds, recipients: recipients, onClick: _this.handleContinue }),
                            React.createElement(ConfirmationPopup, { title: "wallet.tenant.transfer.confirmationPopup.title", topText: React.createElement(React.Fragment, null,
                                    React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.confirmationPopup.text1.top", values: {
                                            credit: formatCurrency({ currencyCode: currency, value: totalAmount, isCents: false })
                                        } }),
                                    _this.buildUsers(),
                                    React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.confirmationPopup.text1.bottom" })), bottomText: React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.confirmationPopup.text2", values: {
                                        boldText: (React.createElement(Strong, null,
                                            React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.confirmationPopup.text2Bold" })))
                                    } }), show: showPreConfirmationPopup, onHide: _this.handleHide, onClick: function () {
                                    _this.handleHide();
                                    _this.handleClick(mutate);
                                }, backButtonText: "platform.button.goBack", continueButtonText: React.createElement(FormattedMessage, { id: "wallet.tenant.transfer.button.allocate" }) })));
                    }),
                    showConfirmation && (React.createElement(CreditTransferConfirmationPopup, { show: showConfirmation, handleClose: _this.handleClose, handleRepeatAgain: _this.handleRepeatAgain, recipients: recipients, transferType: TenantWalletTransferType.TRANSFER, amount: amount, totalAmount: totalAmount, remainingAmount: remainderBalance.amount, currency: currency }))));
            })));
    };
    return TenantWalletTransfer;
}(PureComponent));
export default TenantWalletTransfer;
